import { useState, useEffect } from 'react';
import styles from './logged-in.module.css';
import axios from 'axios';
import cookie from 'js-cookie';
import Bugsnag from '@bugsnag/js';

export default function LoginForm({FontColor, org_id}) {
    const checkLogin = () => {
        axios.get(process.env.NEXT_PUBLIC_API_URL + '/public/me', {
            headers: {
                "Content-Type": "application/json",
                Authorization: cookie.get("token")
            }
        }).then(res => { if('user_id' in res.data) { Bugsnag.setUser(res.data.user_id, res.data.email_address, res.data.first_name + ' ' + res.data.last_name); } }, error => { });
    };

    useEffect(() => { checkLogin() }, [])

    return ( <li><a href="/account" style={{color:FontColor}}>My Account</a></li> )
}
